import {mask} from 'vue-the-mask'
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import AccreditedbrokerRepository from '@/shared/http/repositories/realestate/accreditedbroker'

export default{
  mixins: [ActionsForm],
  props: ['id'],
  data () {
    return {
      name: 'brokerlink',
      mixins: [ActionsForm],
      edit: false,
      newUserData: {
        Nome: '',
        Email: '',
        DataNascimento: null,
        Creci: '',
        EstadoId: '',
        Rg: '',
        Cpf: '',
        Celular: '',
        Tipo: -1,
        TelefoneComercial: '',
        Cep: '',
        Cidade: '',
        Endereco: '',
        Bairro: '',
        Numero: '',
        Id: '',
        corretorID: ''
      },
      statesAcronym: [],
      corretorId: '',
      title: 'ADICIONAR NOVO USUÁRIO',
      corretor: [],
      addcorretor: {
        Nome: []
      }
    }
  },
  directives: {mask},
  mounted () {},
  methods: {
    show (obj = {}) {
      if (Object.keys(obj).length !== 0) {
        this.newUserData.Nome = obj.nome
      } else {
        Object.keys(this.newUserData).forEach((Element) => {
          if (Element !== 'dateBir  h') this.newUserData[Element] = ''
        })
        this.title = 'VINCULAR USUÁRIO EXISTENTE'
        this.edit = false
      }
      this.getcorretor()
      this.corretorId = ''
      this.$refs.addbrower.show()
    },
    validateState (ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    getcorretor () {
      AccreditedbrokerRepository.GetUnboundBrokers(this.id)
        .then(Response => {
          this.corretor = Response.data.data
        })
        .catch(() => {})
    },
    onSubmit (e) {
      loading.push()
      this.newUserData.credenciadaId = this.id
      if (this.edit === false) {
        AccreditedbrokerRepository.PostCredenciadaCorretorWeb(this.corretorId, this.id)
          .then(res => {
            if (res.status === 200) {
              this.$emit('onLoad')
              this.$refs['addbrower'].hide()
              toast.success(`Corretor/Administrador adicionado com sucesso`)
              loading.pop()
            }
          })
          .catch(() => {
            toast.error(`Erro ao adicionar o Corretor/Administrador`)
            loading.pop()
          })
      }
    },
    cancelNewBrower (e) {
      this.$refs.addbrower.hide()
      e.preventDefault()
      this.$refs['add-brower-modal'].hide()
      Object.keys(this.newUserData).forEach(key => {
        this.newUserData[key] = ''
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/accredited/components/brokerlink/brokerlink.js